import React, { useLayoutEffect, useState } from 'react';
import { useQueryClient } from 'react-query'
import { findArray, filterArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

import { useContext } from "react";
import { LegendsContext } from "components/common/legendContext";
import { dateFormat } from "helpers/utils"

export default function SportCode({ discipline, entity, code, abbr, isText, small }) {

    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
    const isAbbr = abbr || false // default value to false
    const _isText = isText || false // default value to false
    discipline = discipline || mirs_discipline

    const filter = {
        disciplineCode: [discipline],
        entityCode: [entity],
        sportCode: [code]
    }


    const description = findArray(data, filter).description;
    let spCode = code;
    if (entity === '@AthleteStatus' && discipline === 'FBL') {
        switch (code) {
            case 'ABSENT':
                spCode = 'A'
                break;
            case 'BOOKED':
                spCode = 'X'
                break;
            case 'INJURED':
                spCode = 'I'
                break;
            case 'SUSPEND':
                spCode = 'N'
                break;
            default:
        }
    } else if (entity === '@AthleteStatus' && discipline === 'HBL') {
        switch (code) {
            case 'INJURED':
                spCode = '(I)'
                break;
            case 'SUSPEND':
                spCode = '(S)'
                break;
            default:
        }
    }
    if (_isText) {
        return (description)
    }
    return (
        <>
            {isAbbr
                ? <abbr className={small && 'small'} title={description}>{spCode}</abbr>
                : <span className={small && 'small'}>{description}</span>
            }
        </>
    );
}


export function getSportCodeObject(data, discipline, entity, code) {
    const filter = {
        disciplineCode: [discipline],
        entityCode: [entity],
        sportCode: [code]
    }

    let objSportCode = findArray(data, filter);


    return (
        objSportCode

    );
}

export function getSportCodeEntityObjects(data, discipline, entity) {
    const filter = {
        disciplineCode: [discipline],
        entityCode: [entity],
    }
    let objSportCode = filterArray(data, filter);
    return (
        objSportCode
    );
}



